import { useParams } from 'react-router-dom';

interface RouteParams {
  customerId: string;
  agreementId?: string;
}

/**
 * Custom hook that wraps useParams and strips any query string
 * that may leak into path params in the micro-frontend shell.
 *
 * Usage: Replace `useParams<Params>()` with `useRouteParams()`
 */
export function useRouteParams(): RouteParams {
  const params = useParams<RouteParams>();
  return {
    customerId: params.customerId?.split('?')[0] || '',
    agreementId: params.agreementId?.split('?')[0],
  };
}
